import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MarqueeStrip from "@/components/site/Marquee";
import About from "@/components/site/About";
import Roots from "@/components/site/Roots";
import Story from "@/components/site/Story";
import Books from "@/components/site/Books";
import Poetry from "@/components/site/Poetry";
import News from "@/components/site/News";
import Technology from "@/components/site/Technology";
import Advocacy from "@/components/site/Advocacy";
import Values from "@/components/site/Values";
import Reconciliation from "@/components/site/Reconciliation";
import Mission from "@/components/site/Mission";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="app-root grain">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Roots />
        <Story />
        <Books />
        <Poetry />
        <Technology />
        <News />
        <Advocacy />
        <Reconciliation />
        <Values />
        <Mission />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(28,43,74,0.14)",
            color: "#1c2b4a",
          },
        }}
      />
    </>
  );
}

export default App;
